import React from 'react';
import { useLocation } from 'react-router-dom';

// Minimal SPA pageview tracker for Vercel Web Analytics
export function AnalyticsRouteTracker(): JSX.Element | null {
  const location = useLocation();

  React.useEffect(() => {
    try {
      const va = (window as any).va;
      if (typeof va === 'function') {
        va('pageview');
      }
    } catch {}
  }, [location.pathname, location.search, location.hash]);

  return null;
}

export default AnalyticsRouteTracker;


